import messages from '../../../locale/messages';

const validate = (values) => {
    const errors = {};

    
    return errors;
}

export default validate;